/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass } from "@phosphor-icons/react";
import "./StaffDetails.css";
import api from "../../utils/api";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContentLoader from "react-content-loader";

const StaffDetails = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [ID, setID] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [staffId, setStaffId] = useState("");
  const [lastName, setLastName] = useState("");
  const [roleName, setRoleName] = useState("");
  const [roles, setRoles] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [emailId, setEmailId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [subjectsName, setSubjectsName] = useState([]);
  const [logo, setLogo] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filterRole, setFilterRole] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    auth();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 15);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
    } finally {
      setLoading(false);
    }
  }

  const TableLoader = ({ rows = 10, columns = 10 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  async function fetchSubjects() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getSubjectDetailsForList";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("onchange/onchangeCurl", fd);
      console.log("resp", response)

      if (response.data.data && Array.isArray(response.data.data)) {
        setSubjects(response.data.data);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      setSubjects([]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchRole() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getRoleDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("role/roleCurl", fd);

      if (response.data && Array.isArray(response.data.getRoleDetails)) {
        setRoles(response.data.getRoleDetails);
      } else {
        setRoles([]);
      }
    } catch (error) {
      setRoles([]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchData(page = 1, roleId = filterRole, search = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getUserDetails";
      const role = localStorage.getItem("role");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      if (roleId) {
        fd.append("roleId", roleId);
      }

      if (search.trim() !== "") {
        fd.append("searchTerm", search.trim());
      }

      const response = await api.post("user/userCurl", fd);

      if (response.data && Array.isArray(response.data.getResponse)) {
        setFetchedData(response.data.getResponse);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
      }
    } catch (error) {
      setFetchedData([]);
      setTotalItems(0);
    } finally {
      setDataLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = ID ? "updateStaff" : "addStaff";
      const role = localStorage.getItem("role");

      const subjectsName = selectedSubjects
        .map((subId) => {
          const subject = subjectOptions.find(
            (opt) => Number(opt.value) === Number(subId)
          );
          return subject ? subject.label : null;
        })
        .filter(Boolean);

      const fd = new FormData();
      fd.append("name", firstName);
      fd.append("role", role);
      fd.append("phone", mobileNumber);
      fd.append("staffId", staffId);
      fd.append("role", selectedRoleName);
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("subjects", JSON.stringify(selectedSubjects));
      fd.append("token", token);
      fd.append("subjectsName", JSON.stringify(subjectsName));

      if (ID) {
        fd.append("id", ID);
      }

      const response = await api.post("user/userCurl", fd);
      // console.log("submit", response);
      if (response.data.status === true) {
        toast.success(response.data.data);
        fetchData(currentPage, filterRole, searchTerm);
        setFirstName("");
        setSelectedSubjects([]);
        setMobileNumber("");
        setSelectedRoleName("");
        setShow(false);
        setID(null);
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      toast.error("Error submitting form.");
    } finally {
      setLoading(false);
    }
  }

  const handleShowAdd = () => {
    setShow(true);
    setID(null);
    setFirstName("");
    setSelectedSubjects([]);
    setMobileNumber("");
    setSelectedRoleName("");
    setImagePreview(null);
  };

  async function handleShowEdit(staff) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getDetailsForUpdate";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", staff.id);

      const response = await api.post("user/userCurl", fd);

      if (
        response.data.getRoleDetails &&
        response.data.getRoleDetails.length > 0
      ) {
        const staffDetails = response.data.getRoleDetails[0];
        setFirstName(staffDetails.firstName);
        setEmailId(staffDetails.emailId);
        setMobileNumber(staffDetails.mobileNumber);
        setAddress(staffDetails.address);

        let assignedSubjectIds = [];
        if (staffDetails.assignedSubjects) {
          try {
            let cleanedString = staffDetails.assignedSubjects.replace(
              /[\[\]"\s]/g,
              ""
            );
            assignedSubjectIds = cleanedString
              .split(",")
              .map((id) => id.trim());
          } catch (error) {
            assignedSubjectIds = [];
          }
        }
        setSelectedSubjects(assignedSubjectIds);

        const matchedRole = roles.find((role) => role.id === staffDetails.role);
        setSelectedRoleName(matchedRole ? matchedRole.id : "");
      }
    } catch (error) {
      toast.error("Error fetching staff details");
    }

    setLogo(staff.logo);
    setID(staff.id);
    setShow(true);
  }

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this staff?")) return;

    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "StatusChange";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);
      fd.append("status", "inactive");

      const response = await api.post("user/userCurl", fd);
      toast.success("Staff deleted successfully");
      fetchData(currentPage, filterRole, searchTerm);
    } catch (error) {
      toast.error("Error deleting staff.");
    } finally {
      setLoading(false);
    }
  }

  const handleClose = () => {
    setFirstName("");
    setSelectedSubjects([]);
    setMobileNumber("");
    setSelectedRoleName("");
    setLogo(null);
    setImagePreview(null);
    setID(null);
    setShow(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page, filterRole, searchTerm);
    }
  };

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }
    return pageNumbers;
  };

  const subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: subject.subjectName.trim(),
  }));

  useEffect(() => {
    if (!ID && show) {
      const randomId = "STF" + Math.floor(100000 + Math.random() * 900000);
      setStaffId(randomId);
    }
  }, [ID, show]);

  useEffect(() => {
    fetchData();
    fetchRole();
    fetchSubjects();
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                  Staff Management
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  Manage your institution's staff members
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search staff..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "280px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, filterRole, searchTerm)}
                  />
                </div>

                {/* Filter by Role */}
                <div style={{ minWidth: "180px" }}>
                  <select
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "100%",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      color: "#334155",
                      cursor: "pointer"
                    }}
                    value={filterRole}
                    onChange={(e) => {
                      const roleId = e.target.value;
                      setFilterRole(roleId);
                      setCurrentPage(1);
                      fetchData(1, roleId, searchTerm);
                    }}
                  >
                    <option value="">All Roles</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.roleName}
                      </option>
                    ))}
                  </select>
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add New Staff
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Staff Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "800px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th style={{
                      width: "48px",
                      padding: "14px 8px",
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap"
                    }}>
                      #
                    </th>
                    <th style={{
                      padding: "14px 16px",
                      textAlign: "left",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap"
                    }}>
                      Name
                    </th>
                    <th style={{
                      padding: "14px 16px",
                      textAlign: "left",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap"
                    }}>
                      Email
                    </th>
                    <th style={{
                      padding: "14px 16px",
                      textAlign: "left",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap"
                    }}>
                      Mobile
                    </th>
                    <th style={{
                      padding: "14px 16px",
                      textAlign: "left",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#475569",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                      whiteSpace: "nowrap"
                    }}>
                      Role
                    </th>
                    {(userPermissions.is_edit === "1" ||
                      userPermissions.is_delete === "1") && (
                        <th style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "#475569",
                          textTransform: "uppercase",
                          letterSpacing: "0.4px",
                          whiteSpace: "nowrap"
                        }}>
                          Actions
                        </th>
                      )}
                  </tr>
                </thead>

                {dataLoading ? (
                  <TableLoader rows={6} columns={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 6 : 5} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 6 : 5} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              👥
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No staff members found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm || filterRole
                                ? "Try adjusting your filters or search"
                                : "Add your first staff member"}
                            </div>
                            {!searchTerm && !filterRole && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleShowAdd}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Add First Staff
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((staff, index) => (
                        <tr key={staff.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s",
                          cursor: "pointer"
                        }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#f8fafc"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
                        >
                          <td style={{
                            width: "48px",
                            padding: "6px",
                            fontSize: "12px",
                            color: "#64748b",
                            fontWeight: "500",
                            textAlign: "center",
                            whiteSpace: "nowrap"
                          }}>
                            <div style={{
                              width: "26px",
                              height: "26px",
                              borderRadius: "6px",
                              background: "#f1f5f9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "600",
                              fontSize: "12px",
                              color: "#475569",
                              margin: "0 auto"
                            }}>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap"
                            }}>
                              <div style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "8px",
                                background: "#e2e8f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#475569",
                                fontWeight: "600",
                                fontSize: "14px"
                              }}>
                                {staff.firstName?.charAt(0) || "S"}
                              </div>
                              {staff.firstName}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#64748b"
                            }}>
                              {staff.emailId || "N/A"}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#64748b"
                            }}>
                              {staff.mobileNumber || "N/A"}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#64748b"
                            }}>
                              {staff.roleName || "N/A"}
                            </div>
                          </td>

                          {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                            <td style={{ padding: "12px", textAlign: "center" }}>
                              <div style={{
                                display: "flex",
                                gap: "6px",
                                justifyContent: "center",
                                flexWrap: "wrap"
                              }}>
                                {userPermissions.is_edit === "1" && (
                                  <button
                                    onClick={() => handleShowEdit(staff)}
                                    title="Edit Staff"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#eff6ff",
                                      color: "#3b82f6",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#dbeafe"}
                                    onMouseLeave={(e) => e.target.style.background = "#eff6ff"}
                                  >
                                    <PencilSimpleLine size={14} />
                                  </button>
                                )}

                                {userPermissions.is_delete === "1" && (
                                  <button
                                    onClick={() => handleDelete(staff.id)}
                                    title="Delete Staff"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#fef2f2",
                                      color: "#dc2626",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#fee2e2"}
                                    onMouseLeave={(e) => e.target.style.background = "#fef2f2"}
                                  >
                                    <Trash size={14} />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        toastStyle={{
          borderRadius: "8px",
          fontFamily: "'Inter', sans-serif",
        }}
      />

      {/* Modal for adding/editing staff */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "14px 24px",
          background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
          color: "#fff"
        }}>
          <div>
            <Modal.Title style={{ fontSize: "20px", fontWeight: "700", marginBottom: "4px", color: "#fff" }}>
              {ID ? "✏️ Edit Staff" : "➕ Add New Staff"}
            </Modal.Title>
            <div style={{ fontSize: "13px", opacity: 0.9 }}>
              {ID ? "Update staff information" : "Add a new staff member to your institution"}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={{
          padding: "28px",
          background: "#f8fafc"
        }}>
          <form onSubmit={handleSubmit} id="staff-details-form">
            {/* Profile Photo */}
            <div style={{ marginBottom: "24px" }}>
              <label style={{
                display: "block",
                marginBottom: "12px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Profile Photo
              </label>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                flexWrap: "wrap"
              }}>
                <div style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "12px",
                  background: `url(${imagePreview ||
                    "https://static.vecteezy.com/system/resources/thumbnails/013/360/247/small/default-avatar-photo-icon-social-media-profile-sign-symbol-vector.jpg"
                    }) center/cover`,
                  border: "2px solid #e2e8f0",
                  position: "relative"
                }}>
                  <input
                    type="file"
                    id="imageUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleImageChange}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer"
                    }}
                  />
                </div>
                <div>
                  <div style={{
                    padding: "16px",
                    borderRadius: "10px",
                    border: "1px dashed #cbd5e1",
                    background: "#fff",
                    cursor: "pointer",
                    transition: "all 0.2s"
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.borderColor = "#3E80F9"}
                    onMouseLeave={(e) => e.currentTarget.style.borderColor = "#cbd5e1"}
                  >
                    <label htmlFor="imageUpload" style={{ cursor: "pointer" }}>
                      <div style={{
                        fontSize: "28px",
                        color: "#3E80F9",
                        marginBottom: "8px",
                        display: "flex",
                        justifyContent: "center"
                      }}>
                        <i className="ph ph-upload" />
                      </div>
                      <div style={{
                        fontSize: "12px",
                        color: "#64748b",
                        textAlign: "center",
                        marginBottom: "4px"
                      }}>
                        Click to upload or drag and drop
                      </div>
                      <div style={{
                        fontSize: "11px",
                        color: "#94a3b8",
                        textAlign: "center"
                      }}>
                        PNG, JPG up to 2MB
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px",
              marginBottom: "20px"
            }}>
              {/* Staff ID */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Staff ID <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  id="staffId"
                  name="staffId"
                  value={staffId}
                  placeholder="Enter Staff ID"
                  onChange={(e) => setStaffId(e.target.value)}
                  required
                />
              </div>

              {/* First Name */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  First Name <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  id="firstName"
                  name="firstName"
                  value={firstName}
                  placeholder="Enter First Name"
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>

              {/* Select Role */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Select Role <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <select
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155",
                    cursor: "pointer"
                  }}
                  value={selectedRoleName}
                  onChange={(e) => setSelectedRoleName(e.target.value)}
                  required
                >
                  <option value="">Select a Role</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.roleName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Mobile Number */}
              <div>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155"
                }}>
                  Mobile Number <span style={{ color: "#dc2626" }}>*</span>
                </label>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    fontSize: "14px",
                    outline: "none",
                    transition: "all 0.2s",
                    background: "#fff",
                    color: "#334155"
                  }}
                  id="mobileNumber"
                  name="mobileNumber"
                  placeholder="Enter Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Assign Subjects */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Assign Subjects <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <div style={{
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                background: "#fff"
              }}>
                <Select
                  isMulti
                  options={subjectOptions}
                  value={subjectOptions.filter((opt) =>
                    selectedSubjects.includes(String(opt.value))
                  )}
                  onChange={(selectedOptions) =>
                    setSelectedSubjects(
                      selectedOptions.map((option) => String(option.value))
                    )
                  }

                  menuPortalTarget={document.body}   // ✅ KEY FIX
                  menuPosition="fixed"               // ✅ avoids clipping
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "none",
                      boxShadow: "none",
                      minHeight: "48px"
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,                  // ✅ ABOVE modal
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0"
                    }),
                  }}
                />

              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer style={{
          borderTop: "1px solid #e5e7eb",
          padding: "24px 28px",
          background: "#f8fafc"
        }}>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "12px 28px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
            onMouseEnter={(e) => e.target.style.background = "#e2e8f0"}
            onMouseLeave={(e) => e.target.style.background = "#f1f5f9"}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
              color: "#fff",
              border: "none",
              padding: "12px 28px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => !loading && (e.target.style.transform = "translateY(0)")}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: "8px" }}
                />
                {ID ? "Updating..." : "Adding..."}
              </>
            ) : (
              ID ? "Update Staff" : "Add Staff"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          select:hover, input:hover {
            border-color: #94a3b8 !important;
          }
          
          select:focus, input:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
          
          .select__control {
            border: none !important;
            box-shadow: none !important;
            min-height: 48px;
          }
          
          .select__menu {
            border-radius: 8px !important;
            border: 1px solid #e2e8f0 !important;
          }
        `}
      </style>
    </div>
  );
};

export default StaffDetails;